module.exports = __webpack_public_path__ + "si.svg?fe78acc9a5e57c78ea07ea0a20602c44";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/si.svg
// module id = 1126
// module chunks = 27